module.exports = __webpack_public_path__ + "img/avatar5.c039f67d.png";